module.exports = __webpack_public_path__ + "img/cns_printer_pc15.04b38e2d.png";